import(/* webpackMode: "eager" */ "/vercel/path0/app/assistant/page.tsx");
